import React, { useState, useContext, useMemo, useCallback, useRef } from "react";
import { _fetch } from "Chore/Request";
import { HubContext } from "Redux/Context/context";
import { toggleGlobalModalAction } from "Redux/Actions/actions";
import { VegaNotify } from "@heartlandone/vega";
import {
  VegaFlex,
  VegaModal,
  VegaButton,
  VegaTextarea,
  VegaFont,
} from "@heartlandone/vega-react";
import { PATH } from "Chore/Apis";
import ScoreItems from "./ScoreItems";

const { ADD_GET_FEEDBACK } = PATH;

const FeedbackPopup = ({
  activityId,
  isOpen,
  onClose,
  onSubmit,
  currenFeedBack,
}) => {
  const { globalModalDispatch } = useContext(HubContext);
  const [score, setScore] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [isSumbitDisabled, setIsSumbitDisabled] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const debounceTimerRef = useRef(null);

  const submitFeedback = useCallback(() => {
    if (isSubmitting) {
      return;
    }

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    debounceTimerRef.current = setTimeout(() => {
      setIsSubmitting(true);
      // _toggleModal(true);
      
      _fetch({
        api: ADD_GET_FEEDBACK(activityId),
        method: "POST",
        data: {
          rating: score,
          feedback,
        },
      })
        .then(async (res) => {
          await VegaNotify.open({
            type: "success",
            duration: 3000,
            message: 'The feedback has been saved.',
          });
          onSubmit(res?.payload);
          onClose();
          clearContext();
        })
        .catch( async (error) => {
          console.error('Submit feedback failed:', error);
          await VegaNotify.open({
            type: "error",
            duration: 3000,
            message: 'The feedback could not be saved.',
          });
        })
        .finally(() => {
          setIsSubmitting(false);
          // _toggleModal();
        });
    }, 300);
  }, [isSubmitting, score, feedback, activityId, onSubmit, onClose]);

  // eslint-disable-next-line
  const _toggleModal = (isShow = false) => {
    globalModalDispatch(toggleGlobalModalAction({ isShow }));
  };

  const isView = useMemo(() => !!currenFeedBack, [currenFeedBack]);

  const title = useMemo(() => isView ? "Feedback Details" : "Add Feedback", [isView]);

  const onScoreChange = (score) => {
    setScore(score);
    setIsSumbitDisabled(false);
  };

  const clearContext = () => {
    setScore(0);
    setFeedback('');
    setIsSumbitDisabled(true);
  }

  return (
    <VegaModal
      size={620}
      backdrop={`static`}
      open={isOpen}
      onVegaClose={() => {
        onClose();
        clearContext();
      }}
    >
      <div slot="modal-title">{title}</div>
      <div slot="modal-content">
        <VegaFlex direction="col" gap="size-24">
          <VegaFlex alignItems="center" gap="size-4">
            <VegaFont variant="font-h5">
              How do you feel about this activity?
            </VegaFont>
            <VegaFont color="text-danger-link-active" variant="font-h5">
              *{" "}
            </VegaFont>
          </VegaFlex>
          <ScoreItems
            currentScore={isView ? currenFeedBack.rating : score}
            onItemClick={onScoreChange}
            disabled={isView}
          />
          <VegaTextarea
            label="Comment"
            onVegaChange={(e) => setFeedback(e.detail)}
            value={isView ? currenFeedBack.feedback : feedback}
            disabled={isView}
          />
        </VegaFlex>
      </div>
      {!isView && (
        <div slot="modal-footer">
          <VegaFlex direction="row" gap="size-12" justifyContent={`end`}>
            <VegaButton
              variant="secondary"
              size="small"
              onVegaClick={() => {
                onClose();
                clearContext();
              }}
            >
              Cancel
            </VegaButton>
            <VegaButton
              size="small"
              block="true"
              onVegaClick={submitFeedback}
              disabled={isSumbitDisabled || isSubmitting}
            >
              Submit
            </VegaButton>
          </VegaFlex>
        </div>
      )}
    </VegaModal>
  );
};

export default FeedbackPopup;
